
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"7","cy":"7","r":"7","fill":"#FF8E14"}}),_c('path',{attrs:{"d":"M6.928 3.571v4","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round"}}),_c('circle',{attrs:{"cx":"7","cy":"10","r":"1","fill":"#fff"}})])
          )
        }
      }
    